
<div class="viewbar">
  <slot></slot>
</div>
